import { useState, FormEvent } from "react";
import { API_BASE_URL } from "../utils/api";

interface AdminLoginProps {
  onBack: () => void;
  onLogin: (adminData: {
    adminId: string;
    userName: string;
    accessToken: string;
    refreshToken: string;
  }) => void;
}

export default function AdminLogin({ onBack, onLogin }: AdminLoginProps) {
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    if (!username || !password) {
      setError("Please fill all fields");
      setIsLoading(false);
      return;
    }

    // Call admin login API
    fetch(`${API_BASE_URL}/admins/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        user_name: username,
        password: password
      })
    })
      .then(res => {
        if (!res.ok) {
          return res.json().then(err => {
            throw new Error(err.detail || "Invalid username or password");
          });
        }
        return res.json();
      })
      .then((data) => {
        onLogin({
          adminId: data.admin_id,
          userName: data.user_name,
          accessToken: data.access_token,
          refreshToken: data.refresh_token
        });
      })
      .catch((err) => {
        setError(err.message || "Login failed. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div style={{ 
      padding: "2rem", 
      backgroundColor: "#f8f9fa", 
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <div style={{
        width: "100%",
        maxWidth: "450px"
      }}>
        {/* Header */}
        <div style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: "1rem", 
          marginBottom: "2rem" 
        }}>
          <button 
            onClick={onBack}
            style={{ 
              padding: "0.5rem 1rem", 
              cursor: "pointer",
              backgroundColor: "#6c757d",
              color: "white",
              border: "none",
              borderRadius: "4px",
              fontSize: "0.875rem",
              fontWeight: "bold"
            }}
          >
            ← Back
          </button>
          <h1 style={{ margin: 0, color: "#212529" }}>Admin Login</h1>
        </div>

        {/* Login Card */}
        <div style={{
          padding: "2rem",
          backgroundColor: "white",
          borderRadius: "8px",
          border: "1px solid #dee2e6",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}>
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <label style={{ fontWeight: "bold", color: "#212529", fontSize: "0.95rem" }}>
                Username
              </label>
              <input 
                type="text" 
                value={username} 
                onChange={e => setUsername(e.target.value)}
                disabled={isLoading}
                placeholder="Enter your username"
                style={{ 
                  width: "93%", 
                  padding: "0.75rem",
                  fontSize: "0.95rem",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  fontFamily: "inherit",
                  backgroundColor: isLoading ? "#f8f9fa" : "white",
                  cursor: isLoading ? "not-allowed" : "text"
                }}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
              <label style={{ fontWeight: "bold", color: "#212529", fontSize: "0.95rem" }}>
                Password
              </label>
              <input 
                type="password" 
                value={password} 
                onChange={e => setPassword(e.target.value)}
                disabled={isLoading}
                placeholder="Enter your password"
                style={{ 
                  width: "93%", 
                  padding: "0.75rem",
                  fontSize: "0.95rem",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  fontFamily: "inherit",
                  backgroundColor: isLoading ? "#f8f9fa" : "white",
                  cursor: isLoading ? "not-allowed" : "text"
                }}
              />
            </div>

            {error && (
              <div style={{
                padding: "0.75rem",
                backgroundColor: "#f8d7da",
                color: "#721c24",
                borderRadius: "4px",
                border: "1px solid #f5c6cb",
                fontSize: "0.875rem"
              }}>
                {error}
              </div>
            )}

            <button 
              type="submit" 
              style={{ 
              padding: "0.75rem 1.5rem",
                fontSize: "1rem",
                cursor: isLoading ? "not-allowed" : "pointer",
                backgroundColor: isLoading ? "#6c757d" : "#007bff",
                color: "white",
                border: "none",
                borderRadius: "4px",
                fontWeight: "bold",
              opacity: isLoading ? 0.6 : 1,
              marginTop: "0.5rem"
              }}
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

